<template>
  <section class="NullComponent">
    <transition name="fade-in-text">
      <span v-if="ready">
        Render Error:
        <i>Unknown component: <strong>"{{ properties.type === undefined ? "null or undefined" : properties.type
        }}"</strong>, has it been registered
          in the Component Repo?</i>
      </span>
    </transition>
  </section>
</template>

<script>
export default {
  name: "NullComponent",
  props: [
    "properties"
  ],
  data() {
    return {
      ready: false
    }
  },
  mounted() {
    this.ready = true
  },
};
</script>

<style lang="scss" scoped>
.NullComponent {
  border: solid 2px red;
  padding: 20px 0;
  background: rgba(0, 0, 0, 0.5);
  color: #f4f4f4;

  strong {
    font-weight: bold;
  }

  i {
    font-style: italic;
  }
}

.fade-in-text-enter-active {
  transition: opacity 0.2s ease-out;
}

.fade-in-text-enter-from,
.fade-in-text-leave-to {
  opacity: 0;
}
</style>